import { Suspense } from 'react'

import { useUserFeed } from 'src/shared/features/feed/api/use-user-feed'

import NoActivity from '../empty/no-activity'
import SectionTitle from '../ui/section-title'

import UserFeedCard from './user-feed-card'
import UserFeedListSkeleton from './user-feed-list-skeleton'

type UserFeedListProps = {
  userId: number
  mobile?: boolean
  onGoBack?: () => void
  firstName: string
}

const UserFeedListContent = ({ userId, mobile, onGoBack, firstName }: UserFeedListProps) => {
  const { data: userFeed } = useUserFeed(userId, true)

  if (!userFeed) {
    return (
      <section>
        {!mobile && <SectionTitle title="Activity" onGoBack={onGoBack} />}
        <NoActivity firstName={firstName} />
      </section>
    )
  }

  const posts = userFeed.pages.flatMap((page) => page.results) || []

  return (
    <section>
      {!mobile && <SectionTitle title="Activity" onGoBack={onGoBack} />}
      <div className="mt-9 grid grid-cols-1 gap-[27px] xs:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]">
        {posts.map((post) => (
          <UserFeedCard post={post} key={post.id} type="new" />
        ))}
      </div>
      {posts.length === 0 && <NoActivity firstName={firstName} />}
    </section>
  )
}

const UserFeedList = ({ userId, mobile, onGoBack, firstName }: UserFeedListProps) => {
  return (
    <Suspense fallback={<UserFeedListSkeleton />}>
      <UserFeedListContent userId={userId} mobile={mobile} onGoBack={onGoBack} firstName={firstName} />
    </Suspense>
  )
}

export default UserFeedList
